import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import { fetchEmployees } from "../../../../store/slices/employeeSlice";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import {
  fetchHardwareDescriptions,
  fetchHardwareProjectTracking,
} from "../../../../store/slices/hardwareDescriptionSlice";
import {
  fetchDescriptionTasks,
  fetchDescriptionTasksProjectTracking,
} from "../../../../store/slices/DescriptionTask";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AssignedOPaction from "./AssignedOPaction";
import {
  fetchWorkEntries,
  fetchWorkEntriesProjectTracking,
} from "../../../../store/slices/workentriesSlice";
import ShowAssigedTableManager from "./ShowAssigedTableManager";
import CheckIcon from "@mui/icons-material/Check";
import OmAssignComplete from "./OmAssignComplete";
import AdminLoader from "./../../../../components/common/loader/AdminLoader";
import { MdSearch } from "react-icons/md";
import OldTaskDetails from "./OldTaskDetails";
import ToAssignResources from "./ToAssignResources";
import FileUploadSales from "../../SalesOperations/SaleOperation/ResponseReceived/FileUploadSales";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker.css";
import { updateProjectDueDate } from "../../../../store/slices/projectDueDateSlice";
import OldTaskDetailsHardware from "./OldTaskDetailsHardware";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DateConversion from "../../../../utils/DateConversion";
import ShowAssigedTableManagerHardware from "./ShowAssigedTableManagerHardware";
import { fetchGroups } from "../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../store/slices/MyTraining/myTrainings";
import { consolidateTrainingExpenseRowsForDisplay } from "../../../../utils/trainingOtherExpenseSync";
import {
  mergeProjectDescriptionRowsForAssignUI,
  descriptionTaskOwnerId,
  groupDescriptionTasksByNormalizedDescription,
  canonicalOtherExpenseDescriptionLabel,
  finalDescriptionMatchesNormalizedKey,
} from "../../../../utils/projectAssignDescriptionMerge";

const ProjectAssignManager = ({ isViewOnly = false }) => {
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } =
    DateConversion();
  const dispatch = useDispatch();
  const { employees } = useSelector((state) => state.employees);
  const { projects } = useSelector((state) => state.projects);
  const { entries } = useSelector((state) => state.workentries);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { tasks: persistedDescriptionTasks } = useSelector((state) => state.descriptionTasks);
  const { tasks: legacyPersistedDescriptionTasks } = useSelector((state) => state.descriptionTask || { tasks: [] });
  const { group: groups } = useSelector((state) => state.group);
  const [currentProject, setCurrentProject] = useState(null);
  const [showAttach, setShowAttach] = useState(false);
  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );
  const employeesAssignedRefresh = useSelector(
    (state) => state.assignSlice.employeesAssignedRefresh
  );
  const employeesCancelAssignedRefresh = useSelector(
    (state) => state.projectAssignCancelState.employeesCancelAssignedRefresh
  );
  console.log("employeesCancelAssignedRefresh emp", employeesCancelAssignedRefresh);

  const [isLoading, setIsLoading] = useState(false);
  const loggedUserEmail = localStorage.getItem("email");
  const [showAction] = useState({ 0: "tasktable" });

  useEffect(() => {
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchWorkEntries());
    dispatch(fetchEmployees());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchAllProjects());
    dispatch(fetchGroups());
    dispatch(getMyTrainings());
  }, [dispatch, employeesAssignedRefresh]);

  const groupNameById = React.useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = React.useCallback(
    (projectRow) => {
      const groupId = projectRow?.groupid?._id || projectRow?.groupid;
      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }
      return projectRow?.AssignedGroup || "";
    },
    [groupNameById]
  );

  useEffect(() => {
    console.log("employeesAssignedRefresh emp", employeesAssignedRefresh);
  }, [employeesAssignedRefresh])

  const refreshAssign = () => {
    dispatch(fetchDescriptionTasks());
    dispatch(fetchWorkEntries());
    dispatch(fetchEmployees());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchAllProjects());
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(getMyTrainings());
  };

  const [assignedProjectsManager, setAssignedProjectsManager] = useState([]);

  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.managerstatus === "project assigned"
        )
    );
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) =>
          person.email?.toLowerCase() === loggedUserEmail.toLowerCase()
      )
    );
    setAssignedProjectsManager(managerProjects);
  }, [projects, loggedUserEmail, employeesCancelAssignedRefresh]);

  const [sortedProjects, setSortedProjects] = useState([]);

  useEffect(() => {
    setSortedProjects(assignedProjectsManager);
  }, [assignedProjectsManager]);

  const itemsPerPage = 10; // or any number of rows you want per page
  const [currentPage, setCurrentPage] = useState(1);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
    filterLeadReports(query);
  };

  const totalItems = sortedProjects.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedProjects = sortedProjects.slice(startIdx, endIdx);

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = assignedProjectsManager.filter((LeadReport) =>
      getDisplayGroupName(LeadReport).toLowerCase().includes(lowerCaseQuery) ||
      Object.entries(LeadReport).some(([key, value]) => {
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value); // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setSortedProjects(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    let sorted = [...sortedProjects]; // Always sort from the filtered dataset

    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) => compareStrings(getDisplayGroupName(a), getDisplayGroupName(b)));
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) => compareStrings(getDisplayGroupName(b), getDisplayGroupName(a)));
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // Default to original filtered order
        sorted = [...sortedProjects];
        break;
    }
    setSortedProjects(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const [openRowId, setOpenRowId] = useState(null);

  const [selectedProjectId, setSelectedProjectId] = useState(null);

  const handleSelectProject = (projectId) => {
    if (projectId !== selectedProjectId) {
      setSelectedProjectId(projectId);
    }
  };

  const handleSelectProjectDescription = (projectId) => {
    if (projectId !== selectedProjectId) {
      setSelectedProjectId(projectId);
    }
  };

  const handleSelectProjectHardwareParts = (projectId) => {
    if (projectId !== selectedProjectId) {
      setSelectedProjectId(projectId);
    }
  };

  const [employeesAssignedData, setEmployeesAssignedData] = useState([]);


  useEffect(() => {
    if (!assignedProjectsManager?.length || !employees?.length || employeesAssignedRefresh || employeesCancelAssignedRefresh) {
      setEmployeesAssignedData([]);
      return;
    }
    const trackingWorkEntries = projectTrackingWorkEntries || [];
    const descriptions = descriptionProjectTracking || [];
    const hardwareParts = hardwareProjectTracking || [];

    const result = assignedProjectsManager.map((project) => {
      const allProjectParts = hardwareParts.filter(
        (part) => part.projectid === project?._id
      );
      const GroupByPartsByAssemblyPartDescription = {};
      allProjectParts.forEach((part) => {
        if (
          !GroupByPartsByAssemblyPartDescription[part.assemblepartdescription]
        ) {
          GroupByPartsByAssemblyPartDescription[part.assemblepartdescription] =
            [];
        }
        GroupByPartsByAssemblyPartDescription[
          part.assemblepartdescription
        ].push(part);
      });
      const empData = project.Assignedperson.map((person) => {
        const emp = employees.find((employee) => {
          const isPM = employee.customRoles?.includes("project manager");

          return (
            employee.EmpEmail === person.email &&
            project.TypeService === employee.servicetype &&
            (isPM ? true : person.projecttracktaskStatus != null)
          );
        });

        if (!emp) return null;

        let assignedPersonData = { ...person };
        let fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`;
        let isSelf = false;

        if (
          emp.customRoles?.length === 1 &&
          emp.customRoles[0] === "project manager"
        ) {
          assignedPersonData = { ...person, name: "Self" };
          fullName = "Self";
          isSelf = true;
        }

        // 🔹── Hardware selection logic ────────────────────
        let finalHardwareParts = [];

        if (isSelf || emp.customRoles?.includes("project manager")) {
          const commonDescriptions = Object.keys(
            GroupByPartsByAssemblyPartDescription
          ).filter((desc) => {
            const parts = GroupByPartsByAssemblyPartDescription[desc];
            const owners = new Set(parts.map((p) => p.taskownerid));
            return parts.length > 1 || owners.size > 1;
          });

          const uniqueManagerDescriptions = Object.keys(
            GroupByPartsByAssemblyPartDescription
          ).filter((desc) => {
            const parts = GroupByPartsByAssemblyPartDescription[desc];
            return parts.length === 1 && parts[0].taskownerid === emp._id;
          });

          commonDescriptions.forEach((desc) => {
            const highest = GroupByPartsByAssemblyPartDescription[desc].reduce(
              (p, c) => (c.totalprice > p.totalprice ? c : p)
            );
            finalHardwareParts.push(highest);
          });

          uniqueManagerDescriptions.forEach((desc) => {
            finalHardwareParts.push(
              GroupByPartsByAssemblyPartDescription[desc][0]
            );
          });

          // 🔹 ADD missing operation-only parts to Project Manager
          Object.entries(GroupByPartsByAssemblyPartDescription).forEach(
            ([desc, parts]) => {
              // parts that belong to operations only (not PM)
              const operationParts = parts.filter((p) => {
                const owner = employees.find((e) => e._id === p.taskownerid);
                return (
                  owner?.customRoles?.includes("operations") &&
                  !owner?.customRoles?.includes("project manager")
                );
              });

              if (!operationParts.length) return;

              // highest operation quantity
              const highestOperationPart = operationParts.reduce((p, c) =>
                c.quantity > p.quantity ? c : p
              );

              // check if PM already has this part
              const existingPMPart = finalHardwareParts.find(
                (p) => p.assemblepartdescription === desc
              );

              // if PM does NOT have this part → ADD it
              if (!existingPMPart) {
                finalHardwareParts.push(highestOperationPart);
              }

              // if PM has but operation has higher quantity → REPLACE
              else if (
                highestOperationPart.quantity > existingPMPart.quantity
              ) {
                const idx = finalHardwareParts.findIndex(
                  (p) => p.assemblepartdescription === desc
                );
                finalHardwareParts[idx] = highestOperationPart;
              }
            }
          );
          finalHardwareParts = finalHardwareParts.filter(
            (v, i, self) => i === self.findIndex((x) => x._id === v._id)
          );
        } else {
          finalHardwareParts = allProjectParts.filter(
            (p) => p.taskownerid === emp._id
          );
        }

        // 🔹── Descriptions logic ──────────────────────────
        const allProjectDescriptions = mergeProjectDescriptionRowsForAssignUI({
          projectRow: project,
          trackingRows: descriptions,
          persistedRows: persistedDescriptionTasks,
          legacyPersistedRows: legacyPersistedDescriptionTasks,
          projectsList: projects,
        });

        const descriptionsByName =
          groupDescriptionTasksByNormalizedDescription(allProjectDescriptions);

        let finalDescriptions = [];

        if (project.TypeService === "Hardware") {
          if (isSelf || emp.customRoles?.includes("project manager")) {
            // Self + PM: consolidated other expenses (common descriptions sum manager + operation amounts)
            Object.values(descriptionsByName).forEach((group) => {
              const owners = new Set(
                group.map((g) => String(descriptionTaskOwnerId(g) || ""))
              );

              if (group.length > 1 || owners.size > 1) {
                const managerRow =
                  group.find(
                    (g) => String(descriptionTaskOwnerId(g)) === String(emp._id)
                  ) || group[0];
                finalDescriptions.push({
                  ...managerRow,
                  description: canonicalOtherExpenseDescriptionLabel(
                    managerRow?.description ?? group[0]?.description
                  ),
                  value: group.reduce(
                    (sum, g) => sum + Number(g.value || 0),
                    0
                  ),
                  taskownerid: emp._id,
                });
              } else if (
                String(descriptionTaskOwnerId(group[0])) === String(emp._id) ||
                descriptionTaskOwnerId(group[0]) == null ||
                descriptionTaskOwnerId(group[0]) === ""
              ) {
                finalDescriptions.push({
                  ...group[0],
                  description: canonicalOtherExpenseDescriptionLabel(group[0]?.description),
                  taskownerid: emp._id,
                });
              }
            });

            finalDescriptions = finalDescriptions.filter(
              (v, i, self) => i === self.findIndex((x) => x._id === v._id)
            );

            // Add operation-only descriptions not already on the manager list
            Object.entries(descriptionsByName).forEach(([desc, group]) => {
              const operationDescriptions = group.filter((d) => {
                const owner = employees.find(
                  (e) => String(e._id) === String(descriptionTaskOwnerId(d))
                );
                return (
                  owner?.customRoles?.includes("operations") &&
                  !owner?.customRoles?.includes("project manager")
                );
              });

              if (!operationDescriptions.length) return;

              const highestOperationDescription = operationDescriptions.reduce(
                (p, c) => (Number(c.value) > Number(p.value) ? c : p)
              );

              const existingPMDescription = finalDescriptions.find((d) =>
                finalDescriptionMatchesNormalizedKey(d, desc)
              );

              if (!existingPMDescription) {
                finalDescriptions.push({
                  ...highestOperationDescription,
                  description: canonicalOtherExpenseDescriptionLabel(
                    highestOperationDescription?.description
                  ),
                });
              } else if (
                Number(highestOperationDescription.value) >
                Number(existingPMDescription.value)
              ) {
                const idx = finalDescriptions.findIndex((d) =>
                  finalDescriptionMatchesNormalizedKey(d, desc)
                );
                finalDescriptions[idx] = {
                  ...highestOperationDescription,
                  description: canonicalOtherExpenseDescriptionLabel(
                    highestOperationDescription?.description
                  ),
                };
              }
            });
          } else {
            finalDescriptions = allProjectDescriptions.filter(
              (d) => String(descriptionTaskOwnerId(d)) === String(emp._id || "")
            );
          }
        } else {
          finalDescriptions = allProjectDescriptions.filter(
            (d) => String(descriptionTaskOwnerId(d)) === String(emp._id || "")
          );
        }
        finalDescriptions = consolidateTrainingExpenseRowsForDisplay(finalDescriptions);

        return {
          projectid: project._id,
          Assignedperson: assignedPersonData,
          fullName,
          email: emp.EmpEmail,
          _id: emp._id,
          EmpGroups: emp?.EmpGroups || [],
          customRole: emp.customRoles,
          TypeService: project.TypeService,
          workEntries: trackingWorkEntries.filter(
            (t) => t.taskownerid === emp._id && t.projectid === project._id
          ),
          DescriptionList: finalDescriptions,
          HardwareParts: finalHardwareParts,
          partsByDescription: GroupByPartsByAssemblyPartDescription,
          currentProjectParts: allProjectParts,
        };
      }).filter(Boolean);

      return {
        projectId: project._id,
        ProjectName: project.ProjectName,
        data: empData,
      };
    });

    setEmployeesAssignedData(result);
  }, [
    assignedProjectsManager,
    employees,
    projectTrackingWorkEntries,
    descriptionProjectTracking,
    hardwareProjectTracking,
    employeesAssignedRefresh,
    employeesCancelAssignedRefresh,
    persistedDescriptionTasks,
    legacyPersistedDescriptionTasks,
    projects,
  ]);


  // const employeesAssignedData = useEmployeesAssignedData({
  //   assignedProjectsManager,
  //   employees,
  //   projectTrackingWorkEntries,
  //   descriptionProjectTracking,
  //   hardwareProjectTracking,
  //   // employeesAssignedRefresh
  // });

  // const prevRef = useRef();

  // useEffect(() => {
  //   if (
  //     JSON.stringify(prevRef.current) !== JSON.stringify(employeesAssignedData)
  //   ) {
  //     prevRef.current = employeesAssignedData;
  //   }
  // }, [employeesAssignedData]);

  // useEffect(() => {
  //   if (assignedProjectsManager.length > 0 && employees.length > 0) {
  //     const tasks = projectTrackingWorkEntries || [];
  //     const descriptions = descriptionProjectTracking || [];
  //     const hardwareParts = hardwareProjectTracking || [];

  //     const result = assignedProjectsManager.map((project) => {
  //       // Get all hardware parts for this project
  //       const allProjectParts = hardwareParts.filter(
  //         (part) => part.projectid === project?._id
  //       );
  //       // Group parts by description for the entire project
  //       const partsByDescriptionForProject = {};
  //       allProjectParts.forEach((part) => {
  //         if (!partsByDescriptionForProject[part.assemblepartdescription]) {
  //           partsByDescriptionForProject[part.assemblepartdescription] = [];
  //         }
  //         partsByDescriptionForProject[part.assemblepartdescription].push(part);
  //       });

  //       const empData = project.Assignedperson.map((person) => {
  //         const emp = employees.find((employee) => {
  //           const isProjectManager =
  //             employee.customRoles?.includes("project manager");
  //           return (
  //             employee.EmpEmail === person.email &&
  //             project.TypeService === employee.servicetype &&
  //             (isProjectManager
  //               ? true // ✅ skip status validation
  //               : person.projecttracktaskStatus !== undefined &&
  //                 person.projecttracktaskStatus !== null)
  //           );
  //         });
  //         if (!emp) return null;
  //         let assignedPersonData = { ...person };
  //         let fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`;
  //         let isSelf = false;
  //         if (
  //           Array.isArray(emp.customRoles) &&
  //           emp.customRoles.length === 1 &&
  //           emp.customRoles[0] === "project manager"
  //         ) {
  //           assignedPersonData = { ...person, name: "Self" };
  //           fullName = "Self";
  //           isSelf = true;
  //         }
  //         let finalHardwareParts = [];
  //         if (isSelf || emp.customRoles?.includes("project manager")) {
  //           // Find descriptions that are common (have more than 1 part OR have parts from different owners)
  //           const commonDescriptions = Object.keys(
  //             partsByDescriptionForProject
  //           ).filter((description) => {
  //             const partsInGroup = partsByDescriptionForProject[description];
  //             // Check if there are multiple parts OR if parts have different owners
  //             const uniqueOwners = new Set(
  //               partsInGroup.map((p) => p.taskownerid)
  //             );
  //             return partsInGroup.length > 1 || uniqueOwners.size > 1;
  //           });
  //           // Find descriptions that are unique to manager
  //           const uniqueManagerDescriptions = Object.keys(
  //             partsByDescriptionForProject
  //           ).filter((description) => {
  //             const partsInGroup = partsByDescriptionForProject[description];
  //             // Check if all parts in this group belong to the manager
  //             return (
  //               partsInGroup.length === 1 &&
  //               partsInGroup[0].taskownerid === emp._id
  //             );
  //           });
  //           // 1. For common descriptions, take the highest totalprice part
  //           commonDescriptions.forEach((description) => {
  //             const partsInGroup = partsByDescriptionForProject[description];
  //             if (partsInGroup.length > 0) {
  //               // Find the part with highest totalprice in this group
  //               const highestPricePart = partsInGroup.reduce((prev, current) =>
  //                 current.totalprice > prev.totalprice ? current : prev
  //               );
  //               finalHardwareParts.push(highestPricePart);
  //             }
  //           });
  //           // 2. Add manager's unique parts
  //           uniqueManagerDescriptions.forEach((description) => {
  //             const partsInGroup = partsByDescriptionForProject[description];
  //             if (
  //               partsInGroup.length === 1 &&
  //               partsInGroup[0].taskownerid === emp._id
  //             ) {
  //               finalHardwareParts.push(partsInGroup[0]);
  //             }
  //           });
  //           // Remove duplicates (in case same part appears multiple times)
  //           finalHardwareParts = finalHardwareParts.filter(
  //             (part, index, self) =>
  //               index === self.findIndex((p) => p._id === part._id)
  //           );
  //         } else {
  //           // For non-project managers (operations), filter their own parts
  //           finalHardwareParts = allProjectParts.filter(
  //             (part) => part.taskownerid === emp._id
  //           );
  //         }

  //         // 🔹 DESCRIPTION LOGIC START
  //         const allProjectDescriptions = descriptions.filter(
  //           (d) => d.projectid === project?._id
  //         );

  //         const descriptionsByName = {};
  //         allProjectDescriptions.forEach((d) => {
  //           if (!descriptionsByName[d.description]) {
  //             descriptionsByName[d.description] = [];
  //           }
  //           descriptionsByName[d.description].push(d);
  //         });

  //         let finalDescriptions = [];
  //         // 🔹 DESCRIPTION LOGIC END

  //         // Filter finalHardwareParts based on assignment and status rules
  //         const filteredHardwareParts = finalHardwareParts.filter(
  //           (entry) =>
  //             (isSelf || emp.customRoles?.includes("project manager")
  //               ? true // Skip ownership check for project managers
  //               : entry.taskownerid === emp._id) &&
  //             entry.projectid === project?._id &&
  //             // ✅ Skip assignment check for PM & OPERATIONS
  //             (emp.customRoles?.includes("project manager") ||
  //             emp.customRoles?.includes("operations")
  //               ? true
  //               : entry?.isProjectAssigned === true) &&
  //             // ✅ Skip submit check for PM & OPERATIONS
  //             (emp.customRoles?.includes("project manager") ||
  //             emp.customRoles?.includes("operations")
  //               ? true
  //               : isSelf
  //               ? entry.taskStatus === "submit"
  //               : true)
  //         );
  //         // 🔹 APPLY DESCRIPTION RULES
  //         if (project?.TypeService === "Hardware") {
  //           if (isSelf || emp.customRoles?.includes("project manager")) {
  //             // PM → take highest value for common descriptions
  //             Object.keys(descriptionsByName).forEach((desc) => {
  //               const group = descriptionsByName[desc];
  //               const owners = new Set(group.map((g) => g.taskownerid));

  //               if (group.length > 1 || owners.size > 1) {
  //                 const highestValueDesc = group.reduce((p, c) =>
  //                   c.value > p.value ? c : p
  //                 );
  //                 finalDescriptions.push(highestValueDesc);
  //               } else {
  //                 if (group[0].taskownerid === emp._id) {
  //                   finalDescriptions.push(group[0]);
  //                 }
  //               }
  //             });

  //             // remove duplicates
  //             finalDescriptions = finalDescriptions.filter(
  //               (v, i, self) => i === self.findIndex((x) => x._id === v._id)
  //             );
  //           } else {
  //             // OPERATIONS → keep same
  //             finalDescriptions = allProjectDescriptions.filter(
  //               (d) => d.taskownerid === emp._id
  //             );
  //           }
  //         } else {
  //           // NON-HARDWARE → keep old logic
  //           finalDescriptions = descriptions.filter(
  //             (entry) =>
  //               entry.taskownerid === emp._id &&
  //               entry.projectid === project?._id &&
  //               (emp.customRoles?.includes("project manager")
  //                 ? true
  //                 : entry?.isProjectAssigned === true) &&
  //               (emp.customRoles?.includes("project manager")
  //                 ? true
  //                 : isSelf
  //                 ? entry.taskstatus === "submit"
  //                 : true)
  //           );
  //         }

  //         return {
  //           projectid: project?._id,
  //           Assignedperson: assignedPersonData,
  //           fullName,
  //           email: emp.EmpEmail,
  //           _id: emp._id,
  //           customRole: emp.customRoles,
  //           TypeService: project?.TypeService,
  //           workEntries: tasks.filter(
  //             (entry) =>
  //               entry.taskownerid === emp._id &&
  //               entry.projectid === project?._id &&
  //               (emp.customRoles?.includes("project manager")
  //                 ? true
  //                 : entry?.isProjectAssigned === true) &&
  //               (emp.customRoles?.includes("project manager")
  //                 ? true
  //                 : isSelf
  //                 ? entry.taskStatus === "submit"
  //                 : true)
  //           ),
  //           // DescriptionList: descriptions.filter(
  //           //   (entry) =>
  //           //     entry.taskownerid === emp._id &&
  //           //     entry.projectid === project?._id &&
  //           //     (emp.customRoles?.includes("project manager")
  //           //       ? true
  //           //       : entry?.isProjectAssigned === true) &&
  //           //     (emp.customRoles?.includes("project manager")
  //           //       ? true
  //           //       : isSelf
  //           //       ? entry.taskstatus === "submit"
  //           //       : true)
  //           // ),
  //           DescriptionList: finalDescriptions,
  //           HardwareParts: filteredHardwareParts,
  //           partsByDescription: partsByDescriptionForProject,
  //           currentProjectParts: allProjectParts,
  //         };
  //       }).filter(Boolean);
  //       return {
  //         projectId: project._id,
  //         ProjectName: project?.ProjectName,
  //         data: empData,
  //       };
  //     });
  //     setEmployeesAssignedData(result);
  //   }
  // }, [
  //   assignedProjectsManager,
  //   employees,
  //   projectTrackingWorkEntries,
  //   descriptionProjectTracking,
  //   hardwareProjectTracking,
  // ]);

  const [rowId, setRowId] = useState(null);
  const [selectedEmpInDrop, setSelectedEmpInDrop] = useState(null);
  const [employeeWithTasks, setEmployeeWithTasks] = useState([]);
  const ProjectAssignref = useRef(null);

  useEffect(() => {
    if (rowId) {
      const scrollToPosition = ProjectAssignref.current.scrollWidth;
      ProjectAssignref.current.scrollTo({
        left: scrollToPosition,
        behavior: "smooth",
      });
    }
  }, [rowId]);

  const [filteredCancelEmployee, setFilteredCancelEmployee] = useState([]);

  const handleDueDateChange = async (date, projectId) => {
    if (isViewOnly) return;
    if (!date || !projectId) return;
    setIsLoading(true);
    try {
      await dispatch(
        updateProjectDueDate({ id: projectId, ProjectDueDate: date })
      );
    } catch (error) {
      console.error("Failed to update due date:", error);
    } finally {
      setIsLoading(false);
      dispatch(fetchAllProjects());
    }
  };

  const [showListState, setShowListState] = useState("tasktable");
  const [clickedPersonId, setClickedPersonId] = useState(null);

  return (
    <>
      <div className="w-[100%] bg-white">
        {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
        <>
          <div className="flex justify-between items-center p-2  bg-white rounded-t ">
            <div className=" font-semibold">Project Assigned</div>

            <div className="flex gap-2 py-1 px-1 align-middle items-center bg-[#e0e7ff] rounded-full">
              <MdSearch className=" w-5 h-5 text-gray-500" />
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchInputChange}
                placeholder="Search"
                className="bg-[#e0e7ff] outline-none w-[80%]"
              />
            </div>
          </div>
          <div
            ref={ProjectAssignref}
            className="w-full max-h-[85vh]  overflow-auto  justify-center "
          >
            <div className="w-full sticky top-0 z-[1299]">
              <div className="flex  bg-[#E8E8E8] text-black text-xs  text-center">
                <div
                  className={`${rowId?._id ? "" : "w-[80%]"
                    } flex font-semibold`}
                >
                  <div className="h-12 w-12 border text-xs flex justify-center align-middle items-center">
                    Sr. No
                  </div>
                  <div
                    className={`h-12 ${rowId?._id ? "w-28 flex-shrink-0" : "w-[20%]"
                      }  relative border break-all whitespace-normal  p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 `}
                  >
                    <p className="w-[75%] break-words whitespace-normal text-start">
                      Group
                    </p>
                    <div className="w-[25%] flex flex-col -mt-1 ">
                      <ArrowDropUp
                        className="cursor-pointer"
                        sx={{ fontSize: "20px" }}
                        onClick={() =>
                          sortAlphabetically("AssignedGroup", "az")
                        }
                      />
                      <ArrowDropDown
                        className="cursor-pointer -mt-2"
                        sx={{ fontSize: "20px" }}
                        onClick={() =>
                          sortAlphabetically("AssignedGroup", "za")
                        }
                      />
                    </div>
                  </div>
                  <div
                    className={`h-12 ${rowId?._id ? "w-28 flex-shrink-0" : "w-[20%]"
                      } relative border break-all whitespace-normal p-2 truncate flex justify-start items-center align-middle text-xs line-clamp-2`}
                  >
                    <p className="w-[75%] break-words whitespace-normal text-start">
                      Project
                    </p>
                    <div className="w-[25%] flex flex-col -mt-1">
                      <ArrowDropUp
                        className="cursor-pointer"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("ProjectName", "az")}
                      />
                      <ArrowDropDown
                        className="cursor-pointer -mt-2"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("ProjectName", "za")}
                      />
                    </div>
                  </div>
                  <div
                    className={`h-12 ${rowId?._id ? "w-32 flex-shrink-0" : "w-[20%]"
                      } relative border break-all whitespace-normal  p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 `}
                  >
                    <p className=" break-words whitespace-normal text-start pl-2">

                      Date Requested
                    </p>
                    <div className="absolute right-0 flex flex-col -mt-1 pl-2">
                      <ArrowDropUp
                        className="cursor-pointer"
                        sx={{ fontSize: "20px" }}
                        onClick={() =>
                          sortAlphabetically("DateRequested", "az")
                        }
                      />
                      <ArrowDropDown
                        className="cursor-pointer -mt-2"
                        sx={{ fontSize: "20px" }}
                        onClick={() =>
                          sortAlphabetically("DateRequested", "za")
                        }
                      />
                    </div>
                  </div>
                  <div
                    className={`h-12 ${rowId?._id ? "w-28 flex-shrink-0" : "w-[20%]"
                      }  relative border break-all whitespace-normal  p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 `}
                  >
                    <p className=" break-words whitespace-normal text-start pl-2">
                      {" "}
                      Due Date
                    </p>
                    <div className="absolute right-1 flex flex-col -mt-1">
                      <ArrowDropUp
                        className="cursor-pointer"
                        sx={{ fontSize: "20px" }}
                        onClick={() =>
                          sortAlphabetically("ProjectDueDate", "az")
                        }
                      />
                      <ArrowDropDown
                        className="cursor-pointer -mt-2"
                        sx={{ fontSize: "20px" }}
                        onClick={() =>
                          sortAlphabetically("ProjectDueDate", "za")
                        }
                      />
                    </div>
                  </div>
                  <div
                    className={`h-12 ${rowId?._id ? "w-28 flex-shrink-0" : "w-[20%]"
                      } flex justify-center items-center border p-2 break-words text-wrap`}
                  >
                    Attachment
                  </div>
                </div>
                {rowId?._id ? (
                  <div className="h-12 font-semibold flex bg-[#E8E8E8] text-black  ">
                    <div className="w-28 p-1 border break-words text-wrap flex justify-start items-center">
                      Select Employee
                    </div>
                    <div className="w-[30rem] h-full border break-words text-wrap flex flex-col justify-center items-center">
                      <div className="w-full h-[50%] border break-words text-wrap flex justify-center items-center">
                        Tasks Details
                      </div>
                      <div className="w-full h-[50%] border break-words text-wrap flex ">
                        <div
                          onClick={() => setShowListState("tasktable")}
                          className={`w-[50%] ${showListState === "tasktable"
                            ? "bg-blue-500 text-white"
                            : "text-black"
                            } p-1 cursor-pointer flex justify-center items-center`}
                        >
                          {String(rowId?.TypeService ?? "").toLowerCase().includes("hardware")
                            ? "Part List"
                            : "Effort Expenses"}
                        </div>
                        <div
                          onClick={() => setShowListState("otherexpenses")}
                          className={` w-[50%] ${showListState === "otherexpenses"
                            ? "bg-blue-500 text-white"
                            : "text-black"
                            } p-1 cursor-pointer flex justify-center items-center`}
                        >
                          Other Expenses
                        </div>
                      </div>
                    </div>
                    <div className="w-28  border p-2 break-words text-wrap flex justify-center items-center">
                      Action
                    </div>
                  </div>
                ) : (
                  <div className="h-12 font-semibold flex justify-center items-center bg-[#E8E8E8] text-black w-[20%]">
                    <div className="w-full p-2 break-words text-wrap">
                      Task Details
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="w-full ">
              {paginatedProjects.map((row, index) => {
                const matchedRowEntries = projectTrackingWorkEntries.filter(
                  (entry) => entry.projectid === row._id
                );
                const matchedRowDesctiption = descriptionProjectTracking.filter(
                  (entry) => entry.projectid === row._id
                );
                const mergedProjectDescriptionEntries =
                  mergeProjectDescriptionRowsForAssignUI({
                    projectRow: row,
                    trackingRows: matchedRowDesctiption,
                    persistedRows: persistedDescriptionTasks,
                    legacyPersistedRows: legacyPersistedDescriptionTasks,
                    projectsList: projects,
                  });

                const matchedRowHardwareEntries =
                  hardwareProjectTracking.filter(
                    (entry) => entry.projectid === row._id
                  );

                const assignedPersonsForProject =
                  (employeesAssignedData || []).find(
                    (p) => p.projectId === row._id
                  )?.data || [];

                return (
                  <div
                    className={`flex text-xs ${row.isRead === false ? "font-bold" : " "
                      }  cursor-pointer group`}
                    key={index}
                  >
                    <div className={`${rowId?._id ? "" : "w-[80%]"} flex`}>
                      <div
                        onClick={() => {
                          setRowId(rowId?._id === row._id ? null : row);
                          handleSelectProject(row._id, matchedRowEntries);
                          handleSelectProjectDescription(
                            row._id,
                            matchedRowDesctiption
                          );
                          handleSelectProjectHardwareParts(
                            row._id,
                            matchedRowHardwareEntries
                          );
                          handleSelectProject(row._id, matchedRowEntries);
                          handleSelectProjectDescription(
                            row._id,
                            matchedRowDesctiption
                          );
                          handleSelectProjectHardwareParts(
                            row._id,
                            matchedRowHardwareEntries
                          );
                          setOpenRowId(row._id === openRowId ? null : row._id);
                        }}
                        className="w-12 border-b text-xs flex justify-start p-3 align-middle items-center group-hover:bg-gray-100 "
                      >
                        {startIdx + index + 1}
                      </div>
                      <div
                        onClick={() => {
                          setRowId(rowId?._id === row._id ? null : row);
                          handleSelectProject(row._id, matchedRowEntries);
                          handleSelectProjectDescription(
                            row._id,
                            matchedRowDesctiption
                          );
                          handleSelectProjectHardwareParts(
                            row._id,
                            matchedRowHardwareEntries
                          );
                          handleSelectProject(row._id, matchedRowEntries);
                          handleSelectProjectDescription(
                            row._id,
                            matchedRowDesctiption
                          );
                          handleSelectProjectHardwareParts(
                            row._id,
                            matchedRowHardwareEntries
                          );
                          setOpenRowId(row._id === openRowId ? null : row._id);
                        }}
                        className={`${rowId?._id ? "w-28 flex-shrink-0" : "w-[20%]"
                          } border-b break-words whitespace-normal  p-2 truncate flex justify-start items-center align-middle text-xs line-clamp-2 group-hover:bg-gray-100 `}
                      >
                        {getDisplayGroupName(row)}
                      </div>
                      <div
                        onClick={() => {
                          setRowId(rowId?._id === row._id ? null : row);
                          handleSelectProject(row._id, matchedRowEntries);
                          handleSelectProjectDescription(
                            row._id,
                            matchedRowDesctiption
                          );
                          handleSelectProjectHardwareParts(
                            row._id,
                            matchedRowHardwareEntries
                          );
                          handleSelectProject(row._id, matchedRowEntries);
                          handleSelectProjectDescription(
                            row._id,
                            matchedRowDesctiption
                          );
                          handleSelectProjectHardwareParts(
                            row._id,
                            matchedRowHardwareEntries
                          );
                          setOpenRowId(row._id === openRowId ? null : row._id);
                        }}
                        className={`${rowId?._id ? "w-28 flex-shrink-0" : "w-[20%]"
                          } border-b flex justify-start align-middle items-center text-left p-2 group-hover:bg-gray-100 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs`}
                      >
                        {row.ProjectName}
                      </div>
                      <div
                        onClick={() => {
                          setRowId(rowId?._id === row._id ? null : row);
                          handleSelectProject(row._id, matchedRowEntries);
                          handleSelectProjectDescription(
                            row._id,
                            matchedRowDesctiption
                          );
                          handleSelectProjectHardwareParts(
                            row._id,
                            matchedRowHardwareEntries
                          );
                          handleSelectProject(row._id, matchedRowEntries);
                          handleSelectProjectDescription(
                            row._id,
                            matchedRowDesctiption
                          );
                          handleSelectProjectHardwareParts(
                            row._id,
                            matchedRowHardwareEntries
                          );
                          setOpenRowId(row._id === openRowId ? null : row._id);
                        }}
                        className={`${rowId?._id ? "w-32 flex-shrink-0" : "w-[20%]"
                          } border-b flex justify-center align-middle group-hover:bg-gray-100  items-center p-2 break-words text-wrap`}
                      >
                        {row.DateRequested &&
                          !isNaN(new Date(row.DateRequested))
                          ? formatDateByCountry(row.DateRequested)
                          : ""}
                      </div>
                      <div
                        className={`${rowId?._id ? "w-28 flex-shrink-0" : "w-[20%]"
                          } border-b flex  justify-center group-hover:bg-gray-100  align-middle items-center p-2 break-words text-wrap`}
                      >
                        <DatePicker
                          selected={
                            row.ProjectDueDate
                              ? new Date(row.ProjectDueDate)
                              : null
                          }
                          onChange={(date) =>
                            handleDueDateChange(date, row._id)
                          }
                          dateFormat={getDateFormat()}
                          className={`ProjectDueDateSelector w-full h-full text-center outline-none border border-gray-300 p-2 rounded-md bg-white ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                          placeholderText={getDatePlaceholder()}
                          popperClassName="z-[1500]"
                          minDate={new Date()}
                          disabled={isViewOnly}
                        />
                      </div>
                      <div
                        className={`${rowId?._id ? "w-28 flex-shrink-0" : "w-[20%]"
                          } border-b p-2 text-center group-hover:bg-gray-100  flex justify-center align-middle items-center break-words text-wrap`}
                      >
                        <AttachFileIcon
                          className="rotate-12 cursor-pointer"
                          onClick={() => {
                            setCurrentProject(row);
                            setShowAttach(true);
                          }}
                        />
                      </div>
                    </div>

                    <div
                      className={`flex flex-col  ${rowId?._id ? "w-full" : "w-[20%]"
                        } group-hover:bg-gray-100 border-b`}
                    >
                      {rowId?._id === row?._id ? (
                        <>
                          {(employeesAssignedData || [{}])
                            .filter(
                              (project) =>
                                project.projectId === row._id &&
                                project.data.length > 0
                            )
                            .flatMap((project) => project.data)
                            .map((emp, index) => (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                                key={emp._id}
                                className="border-b border-gray-400 text-center flex "
                              >
                                <div className="w-28 p-1 text-start break-words text-wrap items-center justify-center">
                                  <div className="w-full flex justify-between">
                                    <div className="w-[70%]  flex justify-start items-center">
                                      {emp.fullName}
                                    </div>
                                    <div className="w-[30%] flex justify-center items-center ">
                                      {emp.Assignedperson
                                        ?.projecttracktaskStatus ===
                                        "pending" &&
                                        emp.Assignedperson?.operationaction !==
                                        "reject" && (
                                          <span
                                            title="Pending"
                                            className="text-orange-500 text-xl font-bold px-1 ml-2 rounded"
                                          >
                                            !
                                          </span>
                                        )}
                                      {emp.Assignedperson?.operationaction ===
                                        "reject" && (
                                          <span
                                            title="Rejected"
                                            className="text-red-800 text-xl font-bold px-1 ml-2 rounded"
                                          >
                                            !
                                          </span>
                                        )}
                                      {emp.Assignedperson
                                        ?.projecttracktaskStatus ===
                                        "submit" && (
                                          <span
                                            title="Submitted"
                                            className="text-green-600 text-xl font-bold  px-1 ml-2 rounded"
                                          >
                                            <CheckIcon className=" text-green-600" />
                                          </span>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  className="w-[30rem]"
                                >
                                  {String(row?.TypeService ?? "").toLowerCase().includes(
                                    "hardware"
                                  ) ? (
                                    <>
                                      <ShowAssigedTableManagerHardware
                                        refreshAssign={refreshAssign}
                                        index={index}
                                        showAction={showAction}
                                        matchedRowEntries={matchedRowEntries}
                                        row={row}
                                        emp={emp}
                                        setIsLoading={setIsLoading}
                                        employees={employees}
                                        matchedOldRowDesctiption={persistedDescriptionTasks}
                                        matchedOldRowEntries={entries}
                                        showListState={showListState}
                                        clickedPersonId={clickedPersonId}
                                        setClickedPersonId={setClickedPersonId}
                                        allAssignedForProject={assignedPersonsForProject}
                                        projectDescriptionEntries={
                                          mergedProjectDescriptionEntries
                                        }
                                        isViewOnly={isViewOnly}
                                      />
                                    </>
                                  ) : (
                                    <ShowAssigedTableManager
                                      refreshAssign={refreshAssign}
                                      index={index}
                                      showAction={showAction}
                                      matchedRowEntries={matchedRowEntries}
                                      row={row}
                                      emp={emp}
                                      setIsLoading={setIsLoading}
                                      employees={employees}
                                      matchedOldRowDesctiption={persistedDescriptionTasks}
                                      matchedOldRowEntries={entries}
                                      showListState={showListState}
                                      clickedPersonId={clickedPersonId}
                                      setClickedPersonId={setClickedPersonId}
                                      allAssignedForProject={assignedPersonsForProject}
                                      projectDescriptionEntries={
                                        mergedProjectDescriptionEntries
                                      }
                                      isViewOnly={isViewOnly}
                                    />
                                  )}
                                </div>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  className="w-28 flex justify-center p-2 break-words text-wrap items-center"
                                >
                                  <AssignedOPaction
                                    index={index}
                                    row={row}
                                    emp={emp}
                                    setIsLoading={setIsLoading}
                                    isViewOnly={isViewOnly}
                                  />
                                </div>
                              </div>
                            ))}
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            className=""
                          >
                            {String(row?.TypeService ?? "").toLowerCase().includes(
                              "hardware"
                            ) ? (
                              <>
                                <OldTaskDetailsHardware
                                  setIsLoading={setIsLoading}
                                  isLoading={isLoading}
                                  index={index}
                                  row={row}
                                  matchedRowEntries={matchedRowEntries}
                                  matchedRowDesctiption={matchedRowDesctiption}
                                  employees={employees}
                                  matchedRowHardwareEntries={
                                    matchedRowHardwareEntries
                                  }
                                  matchedOldRowDesctiption={persistedDescriptionTasks}
                                  matchedOldRowEntries={entries}
                                  setSelectedEmpInDrop={setSelectedEmpInDrop}
                                  selectedEmpInDrop={selectedEmpInDrop}
                                  setEmployeeWithTasks={setEmployeeWithTasks}
                                  refreshAssign={refreshAssign}
                                  employeeWithTasks={employeeWithTasks}
                                  filteredCancelEmployee={
                                    filteredCancelEmployee
                                  }
                                  isViewOnly={isViewOnly}
                                />
                              </>
                            ) : (
                              <>
                                <OldTaskDetails
                                  setIsLoading={setIsLoading}
                                  isLoading={isLoading}
                                  index={index}
                                  row={row}
                                  matchedRowEntries={matchedRowEntries}
                                  matchedRowDesctiption={matchedRowDesctiption}
                                  employees={employees}
                                  matchedRowHardwareEntries={
                                    matchedRowHardwareEntries
                                  }
                                  matchedOldRowDesctiption={persistedDescriptionTasks}
                                  matchedOldRowEntries={entries}
                                  setSelectedEmpInDrop={setSelectedEmpInDrop}
                                  selectedEmpInDrop={selectedEmpInDrop}
                                  setEmployeeWithTasks={setEmployeeWithTasks}
                                  employeeWithTasks={employeeWithTasks}
                                  filteredCancelEmployee={
                                    filteredCancelEmployee
                                  }
                                  refreshAssign={refreshAssign}
                                  isViewOnly={isViewOnly}
                                />
                              </>
                            )}
                          </div>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            className=""
                          >
                            <div className="w-28">
                              <ToAssignResources
                                index={index}
                                row={row}
                                setIsLoading={setIsLoading}
                                matchedRowEntries={matchedRowEntries}
                                matchedRowDesctiption={matchedRowDesctiption}
                                matchedRowHardwareEntries={
                                  matchedRowHardwareEntries
                                }
                                setFilteredCancelEmployee={
                                  setFilteredCancelEmployee
                                }
                                filteredCancelEmployee={filteredCancelEmployee}
                                refreshAssign={refreshAssign}
                                isViewOnly={isViewOnly}
                              />
                            </div>
                          </div>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <OmAssignComplete
                              row={row}
                              setIsLoading={setIsLoading}
                              projectTrackingWorkEntries={
                                projectTrackingWorkEntries
                              }
                              descriptionProjectTracking={
                                descriptionProjectTracking
                              }
                              matchedRowHardwareEntries={
                                matchedRowHardwareEntries
                              }
                              items={items}
                              entries={entries}
                              projects={projects}
                              tasks={persistedDescriptionTasks}
                              employeeWithTasks={employeeWithTasks}
                              isViewOnly={isViewOnly}
                            />
                          </div>
                        </>
                      ) : rowId?._id ? (
                        <div
                          onClick={() => {
                            setRowId(rowId?._id === row._id ? null : row);
                            handleSelectProject(row._id, matchedRowEntries);
                            handleSelectProjectDescription(
                              row._id,
                              matchedRowDesctiption
                            );
                            handleSelectProjectHardwareParts(
                              row._id,
                              matchedRowHardwareEntries
                            );
                            handleSelectProject(row._id, matchedRowEntries);
                            handleSelectProjectDescription(
                              row._id,
                              matchedRowDesctiption
                            );
                            handleSelectProjectHardwareParts(
                              row._id,
                              matchedRowHardwareEntries
                            );
                            setOpenRowId(
                              row._id === openRowId ? null : row._id
                            );
                          }}
                          className="flex"
                        >
                          <div className="w-28 p-3"></div>
                          <div className="w-[30rem] pt-4  flex justify-center align-middle items-center">
                            Multiple{" "}
                          </div>
                          <div className="w-28 p-3"></div>
                        </div>
                      ) : (
                        <div
                          onClick={() => {
                            setRowId(rowId?._id === row._id ? null : row);
                            handleSelectProject(row._id, matchedRowEntries);
                            handleSelectProjectDescription(
                              row._id,
                              matchedRowDesctiption
                            );
                            handleSelectProjectHardwareParts(
                              row._id,
                              matchedRowHardwareEntries
                            );
                            handleSelectProject(row._id, matchedRowEntries);
                            handleSelectProjectDescription(
                              row._id,
                              matchedRowDesctiption
                            );
                            handleSelectProjectHardwareParts(
                              row._id,
                              matchedRowHardwareEntries
                            );
                            setOpenRowId(
                              row._id === openRowId ? null : row._id
                            );
                          }}
                          className="w-full h-full flex justify-center items-center pt-2 group-hover:bg-gray-100"
                        >
                          Multiple
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
              {paginatedProjects.length === 0 && (
                <div className="noDataAvailable p-2">No Result Found</div>
              )}
            </div>
          </div>
          <div
            className={`pagination flex justify-between  text-xs items-center bg-white mt-3 pb-2 pl-2 rounded-md ${paginatedProjects.length > 0 ? "p-1" : ""
              } `}
          >
            <div>
              {totalItems > 0 ? (
                <>
                  Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                  {totalItems} Entries
                </>
              ) : (
                <>
                  {paginatedProjects.length > 0 && (
                    <>Showing {paginatedProjects.length} Entries</>
                  )}
                </>
              )}
            </div>

            {totalPages > 1 && (
              <div className="flex">
                <button
                  onClick={() => setCurrentPage(1)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === 1}
                  title="First Page"
                >
                  <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                </button>
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === 1}
                >
                  <ChevronRightIcon className="w-5 h-5 rotate-180" />
                </button>

                {Array.from({ length: 3 }, (_, index) => {
                  const pageNumber = currentPage - 1 + index;
                  if (pageNumber >= 1 && pageNumber <= totalPages) {
                    return (
                      <button
                        key={pageNumber}
                        onClick={() => setCurrentPage(pageNumber)}
                        className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber ? "bg-gray-300" : ""
                          }`}
                      >
                        {pageNumber}
                      </button>
                    );
                  }
                  return null;
                })}

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === totalPages}
                >
                  <ChevronRightIcon className="w-5 h-5" />
                </button>

                <button
                  onClick={() => setCurrentPage(totalPages)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === totalPages}
                  title="Last Page"
                >
                  <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                </button>
              </div>
            )}
          </div>

          {showAttach && (
            <FileUploadSales
              currentProject={currentProject}
              setShowAttach={setShowAttach}
              employees={employees}
              isViewOnly={isViewOnly}
            />
          )}
        </>
      </div>
    </>
  );
};

export default ProjectAssignManager;
